import axios from "axios";
import { useMutation } from "@tanstack/react-query";

import { Keys } from "../_keys";
import { Routes } from "../_routes";

import { urlMaker } from "utils";
import { onResponseDeleteEmployee } from "./helpers";

const deleteEmployee = async ({ id }: DeleteEmployeeReqT) =>
  axios.delete(urlMaker(Routes.DELETE_EMPLOYEE, id));

export const useDeleteEmployee = () =>
  useMutation({
    mutationKey: [Keys.DELETE_EMPLOYEE_MUT],
    mutationFn: deleteEmployee,
    onSettled: onResponseDeleteEmployee,
    cacheTime: Infinity,
  });
